import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

const StatsCard = ({ icon: Icon, label, value, trend, trendLabel, onClick, color = '#2D1B69' }) => {
  const isUp = trend >= 0;
  const trendColor = isUp ? '#4CAF50' : '#F44336';

  return (
    <Card
      sx={{ cursor: onClick ? 'pointer' : 'default', '&:hover': { boxShadow: '0 4px 12px rgba(0,0,0,0.12)' } }}
      onClick={onClick}
    >
      <CardContent sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', p: 3 }}>
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            {label}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 700, mt: 0.5 }}>
            {value}
          </Typography>
          {trend !== undefined && (
            <Box sx={{ display: 'flex', alignItems: 'center', mt: 1.5 }}>
              {isUp ? (
                <TrendingUpIcon sx={{ fontSize: 18, color: trendColor, mr: 0.5 }} />
              ) : (
                <TrendingDownIcon sx={{ fontSize: 18, color: trendColor, mr: 0.5 }} />
              )}
              <Typography variant="body2" sx={{ color: trendColor, fontWeight: 600 }}>
                {Math.abs(trend)}%
              </Typography>
              {trendLabel && (
                <Typography variant="caption" color="text.secondary" sx={{ ml: 0.5 }}>
                  {trendLabel}
                </Typography>
              )}
            </Box>
          )}
        </Box>
        {Icon && (
          <Box
            sx={{
              backgroundColor: `${color}15`,
              borderRadius: 2,
              p: 1.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Icon sx={{ fontSize: 32, color }} />
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default StatsCard;
